import { render, staticRenderFns } from "./Occupy.vue?vue&type=template&id=14a67a0a&scoped=true&"
import script from "./Occupy.vue?vue&type=script&lang=ts&"
export * from "./Occupy.vue?vue&type=script&lang=ts&"
import style0 from "./Occupy.vue?vue&type=style&index=0&id=14a67a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a67a0a",
  null
  
)

export default component.exports